// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"3f2df873","82":"c23b006c","514":"b1e5dc50","605":"53c281c4","951":"48ee6b72","987":"33572aa5","993":"996eb7cc"}[chunkId] + ".chunk.css";
};